import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

export const DEFAULT_CANVAS_LAYOUT_MOBILE_DETENTS: Array<string | number> = [
  '50%',
  '90%',
];

export type CanvasLayoutHeaderContentSlot = 'start' | 'center' | 'end';

export interface CanvasLayoutRegisteredSidePanel {
  id: string;
  title: string;
  closePanel: () => void;
  children: ReactNode;
  loading?: boolean;
  statusText?: string;
  additionalButtons?: ReactNode;
  className?: string;
  mobileDetents: Array<string | number>;
}

interface CanvasLayoutContextValue {
  registerSidePanel: (sidePanel: CanvasLayoutRegisteredSidePanel) => void;
  clearSidePanel: (id: string) => void;
  startHeaderContentContainer: HTMLDivElement | null;
  centerHeaderContentContainer: HTMLDivElement | null;
  endHeaderContentContainer: HTMLDivElement | null;
  registerHeaderContent: (id: string, slot: CanvasLayoutHeaderContentSlot) => void;
  clearHeaderContent: (id: string, slot: CanvasLayoutHeaderContentSlot) => void;
}

export const CanvasLayoutContext =
  createContext<CanvasLayoutContextValue | null>(null);

export function useCanvasLayoutContext(): CanvasLayoutContextValue {
  const context = useContext(CanvasLayoutContext);

  if (context === null) {
    throw new Error(
      'CanvasLayout helpers must be rendered inside a CanvasLayout.',
    );
  }

  return context;
}
